import React, { FC } from 'react'
import { FieldNames } from 'Constants/FieldNames'
import { FormRowAdditionalElement, FormRowComponent, FormRowElement, UISizes } from 'LibNeo'
import { getLockedText } from 'Pages/ibro'
import { HiddenDisplayNoneStyled } from './styled'

export * from './styled'

export interface BgFormRowElementComponentProps {
	fieldName: FieldNames
	fields: FieldNames[]
	lockedElem?: string | JSX.Element
	children: JSX.Element | JSX.Element[]
	lockedFields: FieldNames[]
	label?: string
	size?: UISizes.SMALL | UISizes.MEDIUM
	fixWidth?: boolean
	tooltip?: string
	additionalElement?: JSX.Element
	hiddenFields?: FieldNames[]
	hideFormat?: string
}

export const BgFormRowElement: FC<BgFormRowElementComponentProps> = ({
	fieldName,
	fields,
	lockedElem,
	label,
	lockedFields,
	children,
	size = UISizes.MEDIUM,
	fixWidth,
	tooltip,
	additionalElement,
	hiddenFields,
	hideFormat,
}) => {
	if (!fields.includes(fieldName)) return null

	const isLocked = lockedFields.includes(fieldName)
	const isHidden = hiddenFields?.includes(fieldName)

	return (
		<FormRowComponent isString={isLocked} label={label ?? `broker.${fieldName}`} tooltip={tooltip}>
			{isHidden ? (
				<FormRowElement size={size} fixWidth={fixWidth}>
					{hideFormat || getLockedText(undefined)}
				</FormRowElement>
			) : (
				<>
					<FormRowElement size={size} fixWidth={fixWidth}>
						{isLocked && (lockedElem || '-')}
						<HiddenDisplayNoneStyled isHide={isLocked}>{children}</HiddenDisplayNoneStyled>
					</FormRowElement>
					{additionalElement && (
						<FormRowAdditionalElement>{additionalElement}</FormRowAdditionalElement>
					)}
				</>
			)}
		</FormRowComponent>
	)
}
